module.exports = "/* Work around for primeng not properly handling view encapsulation.\n   ::ng-deep prevents angular from adding encapsulation tags to children selectors */\n:host ::ng-deep .invalid-remitt-entry {\n    /* This is a recration of the bootstrap bg-warn class.\n       Because of the alternating highlight on table rows,\n       !important has to be used. */\n    background-color: #fcf1e5 !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/remittance-entry/remittance-stage/remittance-stage.component.css
// module id = ./src/app/components/remittance-entry/remittance-stage/remittance-stage.component.css
// module chunks = main